import { productServiceClient } from '../../../templates/_shared/apolloClientUtils';
import {
  GetProductsByProductIdsQuery,
  GetProductsByProductIdsQueryVariables,
  SearchProductByIdProductDataFragment,
} from '../../../templates/search-page/components/GetProductsByProductIds.product-service.generated';
import { loader } from 'graphql.macro';
import { getIdFromShopifyGraphQLId } from 'src/scripts/utils/shopify';
import { AloSearchTopSuggestedProducts } from 'src/@types/window-extended';
import { ProductNode } from 'src/scripts/templates/product-listing-page/types';

const GetProductsByProductIdsGQL = loader(
  '../../../../scripts/templates/search-page/components/GetProductsByProductIds.product-service.graphql'
);

export const trackRecentSearch = (searchText: string) => {
  if (searchText.trim().length > 0) {
    const getRecentSearchData = localStorage.getItem('alo-recent-search');
    const haveRecentSearch = getRecentSearchData && getRecentSearchData?.length > 0;
    let recentSearch: string[] = haveRecentSearch && getRecentSearchData ? JSON.parse(getRecentSearchData) : [];
    recentSearch.push(searchText);
    recentSearch = Array.from(new Set(recentSearch));
    if (recentSearch.length > 5) {
      recentSearch.shift();
    }
    localStorage.setItem('alo-recent-search', JSON.stringify(recentSearch));
  }
};
// ? [REVISIT] Smelly workaround to avoid rebuilding a whole search component. https://alodigital.atlassian.net/browse/ECOM-1818
export const handleNavigationWithArrowKeys = (e: React.KeyboardEvent, url: string) => {
  if (e.key === 'Enter') {
    window.location.href = url;
  } else if (e.key === 'ArrowDown') {
    e.preventDefault();
    const nextTarget = e.currentTarget.nextElementSibling as HTMLElement | null;
    if (nextTarget) {
      nextTarget.focus();
    } else {
      const nextBlockTarget = document.querySelector('.trending-search-block .search-link');
      nextBlockTarget && nextBlockTarget.focus();
    }
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();
    const nextTarget = e.currentTarget.previousElementSibling as HTMLElement | null;
    if (nextTarget) {
      nextTarget.focus();
    } else {
      const input = document.getElementById('SearchInput');
      input && input.focus();
    }
  }
};

export const getAloSuggestedProducts = (suggestedProducts: AloSearchTopSuggestedProducts[]) => {
  return suggestedProducts.map((suggestedProduct) => {
    return {
      link: suggestedProduct.url,
      title: suggestedProduct.title,
      image_link: suggestedProduct.image_url,
      price: suggestedProduct.price.toString(),
      list_price: suggestedProduct.list_price.toString(),
      product_id: suggestedProduct.product_id,
    };
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getPlpTileCompliantProductNodes = async (productsList: any[]) => {
  const productIds = productsList.map((item) => item.product_id.toString());
  const psResponse = await productServiceClient.query<
    GetProductsByProductIdsQuery,
    GetProductsByProductIdsQueryVariables
  >({
    query: GetProductsByProductIdsGQL,
    variables: {
      productIds,
    },
  });

  const plpTileCompliantProductNodes: ProductNode[] = [];
  productIds.forEach((productId) => {
    const found = psResponse?.data?.productsByProductIds.find(
      (item: { gid: string }) => getIdFromShopifyGraphQLId(item.gid) === productId
    );
    if (found) {
      plpTileCompliantProductNodes.push(searchRespProductServiceProductToProductNode(found));
    }
  });
  return plpTileCompliantProductNodes;
};

export const searchRespProductServiceProductToProductNode = (
  productServiceData: SearchProductByIdProductDataFragment
): ProductNode => {
  return {
    ...productServiceData,
    __typename: 'ProductNode',
    id: window.btoa(productServiceData.gid),
    images: {
      __typename: 'Images',
      edges: productServiceData.images.map((imageUrl: string) => {
        return {
          __typename: 'ImagesEdge',
          node: {
            __typename: 'ImageNode',
            originalSrc: imageUrl,
          },
        };
      }),
    },
    priceRange: {
      __typename: 'PriceRange',
      maxVariantPrice: {
        __typename: 'VariantPrice',
        amount: productServiceData.priceRange.maxVariantPrice.amount.toString(),
      },
      minVariantPrice: {
        __typename: 'VariantPrice',
        amount: productServiceData.priceRange.minVariantPrice.amount.toString(),
      },
    },
    compareAtPriceRange: {
      __typename: 'PriceRange',
      maxVariantPrice: {
        __typename: 'VariantPrice',
        amount: productServiceData.compareAtPriceRange.maxVariantPrice.amount.toString(),
      },
      minVariantPrice: {
        __typename: 'VariantPrice',
        amount: productServiceData.compareAtPriceRange.minVariantPrice.amount.toString(),
      },
    },
    availableColors: productServiceData.availableColorsMetafieldValue
      ? {
          __typename: 'Metafield',
          value: productServiceData.availableColorsMetafieldValue,
        }
      : null,
    onlineStoreUrl: productServiceData.onlineStoreUrl,
    // ? [REVISIT] does shopify return null Inventory?
    totalInventory: productServiceData.totalInventory ?? 0,
  };
};

export const truncateSearchText = (text: string, maxLength: number): string => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  } else {
    return text;
  }
};
